export default "__VITE_ASSET__91096468__"